// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._7fdab5{position:sticky;z-index:5;background:linear-gradient(var(--background) 70%, rgba(255, 255, 255, 0));box-shadow:0 calc(-1*var(--medium-spacer)) 0 calc(var(--spacer)/2) var(--background);padding-bottom:var(--spacer);opacity:.975}._0024f1{z-index:9}", ""]);
// Exports
exports.locals = {
	"sticky": "_7fdab5",
	"main": "_0024f1"
};
module.exports = exports;
